export const NOTIFICATIONS_LOADING_START = 'NOTIFICATIONS/LOADING_START';
export const NOTIFICATIONS_DATA_LOADING_START = 'NOTIFICATIONS/DATA_LOADING_START';
export const NOTIFICATIONS_LOADING_END = 'NOTIFICATIONS/LOADING_END';
export const NOTIFICATIONS_DATA_LOADING_END = 'NOTIFICATIONS/DATA_LOADING_END';
export const NOTIFICATIONS_GET_LIST = 'NOTIFICATIONS/GET_NOTIFICATIONS';
export const NOTIFICATIONS_GET_LIST_FILTER = 'NOTIFICATIONS/GET_NOTIFICATIONS_FILTER';
export const NOTIFICATIONS_GET_UNREAD_COUNT = 'NOTIFICATIONS/GET_UNREAD_COUNT';
export const NEW_NOTIFICATION = 'NOTIFICATIONS/NEW_MESSAGE';
export const NOTIFICATION_MARK_READ = 'NOTIFICATIONS/MARK_AS_READ';
